import * as React from 'react';
import {CreateBreadcrumb, IState} from "./Data";
import {RouteComponentProps} from "react-router";
import {CreateLayout} from "../../layout/CreateLayout";
import {QuestionnaireModel} from "../../model";
import {QuestionnaireForm} from "./form/QuestionnaireForm";

export class QuestionnaireCreate extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      questionnaire: {} as QuestionnaireModel
    }
  }

  render() {
    return (
        <CreateLayout breadcrumb={CreateBreadcrumb} title={'Add new questionnaire'}>
          <QuestionnaireForm {...this.state}/>
        </CreateLayout>
    )
  }
}